import React from 'react'
import "./Everest-Heli.css"
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCalendarCheck,faPhotoFilm,faSliders,faBolt,faCheck,faStar,faXmark, faDownload, faMinus, faPlus, faTag,faEnvelope ,faCalendarDays, faCloud, faGaugeHigh, faArrowRight,faBus, faMapLocationDot, faHotel, faMessage, faSquareArrowUpRight,faChevronDown, faMicrophone,faChevronUp, faBowlFood, faMountain} from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp,faWeixin,} from '@fortawesome/free-brands-svg-icons'
import { useState } from 'react'
import {useEffect}from 'react'
import PackageSlider from "./Component/PackageSlider";
import Bookingform from "./Component/bookingform";
import Enquiryform from "./Component/enquiryform";
import Review from "./Component/review";
import TourNav from './Component/stickynav';
const packages = [
  {
    title: "7 Unesco Heritage Tour",
    days: "4 Hours",
    duration: "8-9 Hours",
    difficulty: "Easy",
    price: 190,
    image: "/img/capital/pasupatinath.jpg",
    link: "/one-day-nepal-7unescoheritage-tour"
  },
  {
    title: "Nepal Golden Triangle Tour",
    location: "Nepal",
    days: "8 Days",
    difficulty: "Easy",
    price: 940,
    duration: "8 Days",
    image: "/img/chitwan/chitwan3dslr.jpeg",
    link: "/kathmandu-chitwan-pokhara-8days-nepaltour"
  },
  {
    title: "Peak & Safaris",
    location: "Nepal",
    days: "6 Days",
    difficulty: "Easy",
    price: 1150,
    duration: "6 Days",
    image: "/img/capital/nagarkot.webp",
    link: "/kathmandu-chitwan-nagarkot"
  },
  {
    title: "Nature Majestic Loop",
    location: "Nepal",
    days: "10 Days",
    difficulty: "Easy",
    price: 2350,
    duration: "10 Days",
    image: "/img/treek/Dhampus.webp",
    link: "/kathmandu-chitwan-lumbini-pokhara-ghandrukh-dhampush-bandipur-nagarkot-10daystour"
  }
];
const images = [
  "/img/company/airportdslr.jpeg",
  "/img/company/me1dslr.jpeg",
  "/img/pokhara/pokhara2dslr.jpeg",
  "/img/pokhara/pokhara4.jpg",
  "/img/company/mewith.jpeg",
  "/img/pokhara/pokhara3dslr.jpeg",
  "/img/pokhara/pokhara1dslr.jpeg",
  "/img/pokhara/tal barahi.webp",
  "/img/company/groupphoto.jpeg",
  "/img/pokhara/pokh.jpg",
  "/img/capital/Nagarkot.avif",
  "/img/capital/pro.png",
  "/img/company/mewith.jpeg",
  "/img/capital/bouddha.webp",
  "/img/capital/pasupatinath.jpg",
  "/img/capital/image-asset.webp",
  "/img/company/medslr.jpeg",
];
const KathmandupokharaTour = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [count,Setcount]=useState(1);
  const [day1Open, setDay1Open] = useState(false);
  const [day2Open, setDay2Open] = useState(false);
  const [day3Open, setDay3Open] = useState(false);
  const [day4Open, setDay4Open] = useState(false);
  const [day5Open, setDay5Open] = useState(false);
  const [day6Open, setDay6Open] = useState(false);
  const next = () => {
    setIndex((index + 1) % images.length);
  };

  const prev = () => {
    setIndex((index - 1 + images.length) % images.length);
  };
  const getmul=(qty)=>{
    if(qty===1)return 890;
if(qty>=2 && qty<=3)return 850;
if(qty>=4 && qty<=7)return 750;
if(qty>=8 && qty<=19)return 690;
if(qty>=20)return 590;
    };
    const totalprice =count*getmul(count);
    const [opent, seT] = useState(false);
    const [opente, seTe] = useState(false);
    const [openr, seTr] = useState(false);
    const [openH, seTh] = useState(false);
    useEffect(()=>{
      if(opent){
        document.body.style.overflow='hidden';
      }
      else{
        document.body.style.overflow='unset';
      }
      return()=>{
        document.body.style.overflow='unset';
      }
    },[opent]);
    useEffect(()=>{
      if(openH){
        document.body.style.overflow='hidden';
      }
      else{
        document.body.style.overflow='unset';
      }
      return()=>{
        document.body.style.overflow='unset';
      }
    },[openH]);
    const [activeIndex, setActiveIndex] = useState(null);
    
      const toggleFaq = (index) => {
        if (activeIndex === index) {
          setActiveIndex(null);
        } else {
          setActiveIndex(index);
        }
      };
  return (
   <main>
 <TourNav />
    <div className='main'>
    <div className='Left'>
    <h1 className="tourTitle">Nepal's Heritage & Horizon Tour</h1>

    <div className="breadcrumb">
    Kathmandu-Nagarkot-Pokhara <span>6 Days Tour</span>
    </div>
     <div className="everest-image">
        <div className="everest-full">
          <img src="/img/capital/capital2dslr.jpeg" alt="error" />
          <div
      className="tourgps"
      onClick={() => setOpen(true)}
    >  <FontAwesomeIcon icon={faPhotoFilm}></FontAwesomeIcon> View Gallery
       </div>  
        </div>
        <div className="everest-half">
            <div className="image-box"> <video src="/video/videodslr.mp4" controls autoPlay muted loop></video></div>
            <div className="image-box"> <img src="/img/capital/myself.jpg" alt="error" /></div>
        </div>
     </div>
     {open && (
  <div className="roomModal tourgr">
    <div className="roomModal__content">

      <div
        className="roomModal__close"
        onClick={() => setOpen(false)}
      >
        ✕
      </div>

      <img
        src={images[index]}
        alt="big"
        className="roomModal__image"
      />

      <div
        className="roomModal__nav roomModal__nav--left"
        onClick={prev}
      >
        ❮
      </div>

      <div
        className="roomModal__nav roomModal__nav--right"
        onClick={next}
      >
         ❯  
      </div>

      <div className="roomModal__thumbs">
        {images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt="thumb"
            className={
              index === i
                ? "roomModal__thumb active"
                : "roomModal__thumb"
            }
            onClick={() => setIndex(i)}
          />
        ))}
      </div>

    </div>
  </div>
)}
    <div className="Trip-fact">
      <h3>Trip Facts</h3>
      <div className="grid">
        <div className="grid-item">
          <FontAwesomeIcon icon={faCalendarDays}/>
          <div className="grid-item-next">
            <p className='Dur'>Duration</p>
            <p className='Duration'>6 Days</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faCloud}/>
          <div className="grid-item-next">
            <p className='Dur'>Best Time</p>
            <p className='Duration'>Whole Year</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faGaugeHigh}/>
          <div className="grid-item-next">
            <p className='Dur'>Grade</p>
            <p className='Duration'>Easy</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faBus}/>
          <div className="grid-item-next">
            <p className='Dur'>Transportation</p>
            <p className='Duration'>Private Vehical</p>
          </div>
        </div>
 
        <div className="grid-item">
          <FontAwesomeIcon icon={faMapLocationDot}/>
          <div className="grid-item-next">
            <p className='Dur'>Type Of Tour</p>
            <p className='Duration'>Exploring Natural Beauty and Culture</p>
          </div>
        </div>

         <div className="grid-item" onClick={()=>seTh(true)}>
          <FontAwesomeIcon icon={faHotel}/>
          <div className="grid-item-next">
            <p className='Dur'>Hotel Included</p>
            <p className='Duration'>4 And 5 Star (Changeable)</p>
          </div>
        </div>
        <div className="grid-item">
          <FontAwesomeIcon icon={faBowlFood}/>
          <div className="grid-item-next">
            <p className='Dur'>Breakfast</p>
            <p className='Duration'>Included</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faMountain}/>
          <div className="grid-item-next">
            <p className='Dur'>Maximum Elevation</p>
            <p className='Duration'>2100 M</p>
          </div>
        </div>

      </div>

       </div>
       <div className="overview-container"id='overview'>
  <div className="heading">Highlights Of Tours</div>
  <div className="flex-p">
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Explore UNESCO World Heritage sites and living history in Kathmandu.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Hear the stories that Google won't tell you.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Relax by the lakes and beneath the shadows of the Annapurna range in Pokhara.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Wake up to a 360-degree panoramic sunrise in Nagarkot.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Enjoy a peaceful boat ride on the crystal-clear Phewa Lake</p>
  </div>
</div>
       <div className="overview-container">
  <div className="overview-heading">Overview</div>

  <div className="overview-text">
  Experience the perfect harmony of ancient culture and Himalayan grandeur. This 6-day curated journey takes you from the medieval streets of the Kathmandu Valley to the tranquil lakeside of Pokhara, finishing with a breathtaking sunrise over the world’s highest peaks in Nagarkot. It is the ideal package for travelers who want to see the "Best of Nepal" without the need for strenuous trekking.
  </div>
  <div className="heading smalling">Places You’ll Visit:</div>
  <div className="flex-p">
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Swayambhunath (Monkey Temple):</b> Ancient hilltop stupa with panoramic city views.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Kathmandu Durbar Square:</b> The historic seat of royalty and the living Goddess Kumari.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Boudhanath Stupa:</b> One of the largest spherical stupas in the world.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Pashupatinath Temple:</b> Nepal’s most sacred Hindu temple and cremation site.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Sarangkot:</b> A famous hilltop destination offering breathtaking sunrise views and a panoramic sweep of the Annapurna Himalayan range.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Davis Fall:</b> An extraordinary waterfall where the Pardi Khola stream disappears into a deep, mysterious underground tunnel.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Bindabasini Temple:</b> The oldest temple in Pokhara, dedicated to Goddess Durga and serving as a vital spiritual hub for local devotees.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Phewa Lake:</b> Nepal's second-largest lake, famous for the Tal Barahi Temple on its island and the stunning reflection of Mount Machhapuchhre on its waters.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Nagarkot:</b> A premier hill station on the edge of the Kathmandu Valley, renowned for its wide-angle views of eight Himalayan ranges, including Mount Everest.</p>
<p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Bhaktapur:</b> An ancient "City of Devotees" renowned for its well-preserved medieval art, stunning woodcarvings, and the iconic 55-Window Palace.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Mahendra Cave:</b> A large limestone cavern in Pokhara, famous for its stalactites, stalagmites, and a sacred statue of Lord Shiva hidden within.</p>
  </div>
  <div className="heading smalling">Introduction Of Places</div>
 <p className='overview-text'><b>Swayambhunath: The All-Seeing Eyes</b> High on a hill, ancient eyes watch over the entire valley. Legend says this place was born from a lotus flower before the city even existed. You will walk among hundreds of monkeys and spinning wheels to find a view that feels like the top of the world. What you see here will stay with you forever.</p>
<p className='overview-text'><b>Boudhanath: The Giant Circle</b> This is one of the biggest stupas in the world, built like a giant meditation map. The air is thick with the smell of butter lamps and the sound of monks chanting. Thousands of people walk in a circle here every day, but the peace you feel inside is a secret you have to experience yourself.</p>
<p className='overview-text'><b>Kathmandu Durbar Square: Home of the Living Goddess</b> Walk through the old royal gates where kings were once crowned. Hidden inside a carved wooden palace lives a real young girl worshipped as a Living Goddess. The temples here are covered in carvings that tell stories from thousands of years ago. It feels like walking through a history book that is still alive.</p>
<p className='overview-text'><b> Pashupatinath: The Holy River Temple</b> This is the most sacred place for Hindus in Nepal, sitting right on the edge of a holy river. You will see golden roofs, wandering holy men, and ancient fire rituals that have not stopped for centuries. It is a powerful place that shows you the true meaning of life and tradition.</p>
<p className='overview-text'><b>Sarangkot: The Himalayan Gateway</b> Perched high above the clouds, this hilltop offers the ultimate front-row seat to the Annapurna giants. As the first light of dawn turns the jagged peaks into molten gold, you will feel the immense scale of the mountains. It is a place of quiet wonder and the perfect start to any Pokhara adventure.</p>

<p className='overview-text'><b>Davis Fall: The Underground Mystery</b> Nature shows its hidden power here, where a roaring waterfall plunges into a dark, bottomless cavern. Unlike any other cascade, the water vanishes into an intricate network of caves, leaving you to marvel at the secrets hidden beneath the earth's surface. It is a striking reminder of the earth's raw beauty.</p>

<p className='overview-text'><b>Bindabasini Temple: The Guardian of Pokhara</b> Standing white and proud against the blue sky, this ancient sanctuary is the spiritual heartbeat of the valley. Dedicated to the fierce Goddess Durga, the air here is thick with the scent of incense and the sound of bells. It is a serene hilltop escape where faith and heritage meet.</p>

<p className='overview-text'><b>Phewa Lake: The Mirror of the Mountains</b> A tranquil expanse of emerald water that perfectly captures the reflection of the sacred Machhapuchhre peak. Whether you are paddling a colorful boat to the island temple or walking along the vibrant shore, the lake offers a sense of peace that calms the soul. It is the true jewel of the Pokhara Valley.</p>

<p className='overview-text'><b>Nagarkot: The Roof of the Valley</b> On the very edge of the Kathmandu rim, this ridge offers a window to the roof of the world. On a clear day, the horizon stretches out to reveal eight different Himalayan ranges, including the distant peak of Everest. It is a place where the air is crisp, the silence is deep, and the views are eternal.</p>
<p className='overview-text'><b>Bhaktapur: The Living Museum</b> Step back in time as you enter this ancient city of devotees, where every brick and woodcarving tells a story from the medieval era. Known for its towering temples and vibrant pottery squares, it is a place where traditions are still lived out daily. Walking through its car-free streets feels like wandering through an open-air gallery of Newari craftsmanship.</p>
<p className='overview-text'><b>Mahendra Cave: The Limestone Labyrinth</b> Venture deep into the earth to explore one of Pokhara’s most famous natural wonders. This dark and mysterious limestone cavern is filled with unique rock formations and sparkling stalactites that hang from the ceiling like natural chandeliers. It is a thrilling journey into the quiet, cool depths of the Himalayan foothills.</p>
</div>
<div className="overview-container">
  <div className="overview-heading">Why This Package ?</div>
 <p className='overview-text'>Planning a trip to a new country can be overwhelming. We’ve designed this 6-day "Golden Loop" package to take the stress out of your travels, allowing you to focus entirely on the beauty of the Himalayas and the warmth of Nepali culture:</p>
 <div className="heading smalling">See the "Best of Nepal" Without the Hike</div>
 <p className='overview-text'>We’ve curated a perfect itinerary that delivers breathtaking Himalayan sunrises and serene lakeside views—all accessible by private vehicle. No strenuous trekking required!</p>
 <div className="heading smalling">Zero Logistics Stress</div>
 <p className='overview-text'>From the moment you land, we take care of everything. We handle all your hotel bookings, private airport transfers, and inter-city transportation. You don’t have to worry about traffic or navigation; just sit back and enjoy the ride.</p>
 <div className="heading smalling">Expert Local Insight</div>
 <p className='overview-text'>A monument is just a pile of stones without its story. Our government-licensed guides are local experts who bring Nepal’s history to life, sharing legends of the Malla kings, the significance of Hindu rituals, and the deep spirituality of Buddhist stupas.</p>
 <div className="heading smalling">Perfectly Paced for You</div>
 <p className='overview-text'>We know the difference between a "tour" and a "vacation." Our itinerary balances exciting morning sightseeing with relaxing afternoons by Pokhara’s Phewa Lake, ensuring you return home feeling refreshed, not exhausted.</p>
 <div className="heading smalling">Safe & Secure Travel</div>
 <p className='overview-text'>Travel with total confidence. Our private tours provide the safety and reliability that solo or independent travelers often miss, with 24/7 support should you need any assistance along the way.</p>
 
</div>

<div className="overview-container">
  <div className="overview-heading"id='itinerary'>ITINERARY</div>
  <div className="timeline-row">
        <div className="timeline-left">
          <div className="day-circle">Day 1</div>
        </div>

        <div
          className="timeline-right"
          onClick={() => setDay1Open(!day1Open)}
        >
         
          <div className="timeline-title">
          Welcome to Kathmandu
          </div>

          <div className="arrow-icon">
            <FontAwesomeIcon icon={day1Open ? faChevronUp : faChevronDown} />
          </div>
        </div>
      </div>

      {day1Open && (
        <div className="timeline-detail">
         Arrive at Tribhuvan International Airport. Our team will meet you and transfer you to your hotel. Spend the rest of the day relaxing or taking an easy stroll through the vibrant streets of Thamel to soak in the local atmosphere.
        </div>
      )}
<div className="timeline-row time-linemargin">
        <div className="timeline-left">
          <div className="day-circle">Day 2</div>
        </div>
        <div
          className="timeline-right"
          onClick={() => setDay2Open(!day2Open)}
        > 
          <div className="timeline-title">
          The Heart of Kathmandu
          </div>
          <div className="arrow-icon">
            <FontAwesomeIcon icon={day2Open ? faChevronUp : faChevronDown} />
          </div>
          
        </div>
        
</div>
{day2Open && (
        <div className="timeline-detail">
        Enjoy a full day of sightseeing at Nepal’s UNESCO World Heritage sites. You will visit the historic Kathmandu Durbar Square, the sacred Pashupatinath Temple, the peaceful Boudhanath Stupa, and the hilltop Swayambhunath (Monkey Temple).
        </div>
      )}

      <div className="timeline-row time-linemargin">
        <div className="timeline-left">
          <div className="day-circle">Day 3</div>
        </div>
        <div
          className="timeline-right"
          onClick={() => setDay3Open(!day3Open)}
        > 
          <div className="timeline-title">
          Scenic Drive to Pokhara
          </div>
          <div className="arrow-icon">
            <FontAwesomeIcon icon={day3Open ? faChevronUp : faChevronDown} />
          </div>
          
        </div>
        
</div>
{day3Open && (
        <div className="timeline-detail">
        After breakfast, we begin our scenic drive to Pokhara, the "City of Lakes." The journey takes you through lush green hills and along the Trishuli River. Once you arrive, check into your lakeside hotel and enjoy a peaceful evening watching the sunset over Phewa Lake.
        </div>
      )}
      <div className="timeline-row time-linemargin">
        <div className="timeline-left">
          <div className="day-circle">Day 4</div>
        </div>
        <div
          className="timeline-right"
          onClick={() => setDay4Open(!day4Open)}
        > 
          <div className="timeline-title">
          Exploring Pokhara
          </div>
          <div className="arrow-icon">
            <FontAwesomeIcon icon={day4Open ? faChevronUp : faChevronDown} />
          </div>
          
        </div>
        
</div>
{day4Open && (
        <div className="timeline-detail">
       Start your day early with a sunrise trip to Sarangkot for a breathtaking view of the Annapurna and Fishtail peaks. Later, explore Pokhara’s wonders, including Devi’s Fall, the Gupteshwor Mahadev Cave, and the Bindabasini Temple. End the day with a relaxing boat ride on Phewa Lake.
        </div>
      )}
      <div className="timeline-row time-linemargin">
        <div className="timeline-left">
          <div className="day-circle">Day 5</div>
        </div>
        <div
          className="timeline-right"
          onClick={() => setDay5Open(!day5Open)}
        > 
          <div className="timeline-title">
          Drive to Nagarkot via Bhaktapur
          </div>
          <div className="arrow-icon">
            <FontAwesomeIcon icon={day5Open ? faChevronUp : faChevronDown} />
          </div>
          
        </div>
        
</div>
{day5Open && (
        <div className="timeline-detail">
        We depart Pokhara and drive toward the hilltop village of Nagarkot.On the way, we stop to explore the medieval architecture and ancient courtyards of Bhaktapur Durbar Square.We reach Nagarkot by the evening, just in time for a stunning Himalayan sunset.
        </div>
      )}
      <div className="timeline-row time-linemargin">
        <div className="timeline-left">
          <div className="day-circle">Day 6</div>
        </div>
        <div
          className="timeline-right"
          onClick={() => setDay6Open(!day6Open)}
        > 
          <div className="timeline-title">
          Final Sunrise & Departure
          </div>
          <div className="arrow-icon">
            <FontAwesomeIcon icon={day6Open ? faChevronUp : faChevronDown} />
          </div>
          
        </div>
        
</div>
{day6Open && (
        <div className="timeline-detail">
        Wake up to a spectacular sunrise over the Himalayas. After a final morning view of the mountain ranges, we will drive you directly to the Kathmandu airport for your departure, leaving you with memories to last a lifetime.
        </div>
      )}
</div>

<div className="overview-container width-hund"id='included'>

<div className="cost-box included">
        <div className="cost-title">Cost Included</div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">
          Pick Up and Drop with private vehicle is included in this price.
          </div>
        </div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">A Professional native language speaking tour guide.</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">Three nights’ accommodation with breakfast at a 4-star category hotel in Kathmandu.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">All kind of service charge and Tax is included.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">Two nights’ accommodation with breakfast at a 5-star category hotel in Pokhara.</div>
        </div>
        
        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">One night accommodation in Nagarkot 4 Star including breakfast.</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">Transportation for Kathmandu – Pokhara - Nagarkot – Kathmandu by private car. and Flight is also aviailable but it requires (Additional Cost)</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">All the applicable entrance fees.</div>
        </div>
      </div>



      {/* COST EXCLUDED */}
      <div className="cost-box excluded">
        <div className="cost-title">Cost Not Included</div>

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Lunch and Dinner during the tour.</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">International airfare and airport departure tax.</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Tips for the guide & driver.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Nepal Entry visa fee.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Any others expenses which are not mentioned in including section.</div>
        </div>
      </div>

</div>
<div className="overview-container">
  <div className="heading vbn"><FontAwesomeIcon icon={faMessage}></FontAwesomeIcon> FAQS
  </div>
  <section className="faq">
      <div className="faq-container">

        <div className="faq-list">
          <div className="faq-item" onClick={() => toggleFaq(0)}>
            <div className="faq-question">
            Booking & Payment Terms
              <span>{activeIndex === 0 ? "-" : "+"}</span>
            </div>
            {activeIndex === 0 && (
              <div className="faq-answer">
               To confirm your trip, a 10% deposit is required at the time of booking. Upon your arrival in Nepal and transfer to your hotel, 70% of the total fee is due to begin the tour services. The remaining balance payment must be settled in full after the fourth day of your journey.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(1)}>
            <div className="faq-question">
              How can I book a tour?
              <span>{activeIndex === 1 ? "-" : "+"}</span>
            </div>
            {activeIndex === 1 && (
              <div className="faq-answer">
                You can book directly from our website by clicking button  or contact our support team from right side contact details or from contact us page where is a QR for your ease scan and contactus.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(2)}>
            <div className="faq-question">
              Is This Package Suitable For Me ?
              <span>{activeIndex === 2 ? "-" : "+"}</span>
            </div>
            {activeIndex === 2 && (
              <div className="faq-answer">
            This package is perfectly suited for first-time travelers and families looking for a comprehensive introduction to Nepal without the physical demands of high-altitude trekking. It balances the deep historical roots of the Kathmandu Valley’s ancient squares with the tranquil, natural beauty of Pokhara’s lakeside and caves. Because every destination is accessible by vehicle, it is an excellent choice for senior citizens, photographers, or time-constrained tourists who want to experience the "Golden Triangle" of Nepal’s heritage and Himalayan views in comfort and style.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(3)}>
            <div className="faq-question">
              Can I cancel my booking and refund policies?
              <span>{activeIndex === 3 ? "-" : "+"}</span>
            </div>
            {activeIndex === 3 && (
              <div className="faq-answer">
                Yes you can cancel. we understand life will not run according to our plan. There is refund policies Cancel up to 10 days before in advance for a full refund after 10 days there will no refund of your 10% booking fee payment.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(4)}>
            <div className="faq-question">
              Preparation For This package
              <span>{activeIndex === 4 ? "-" : "+"}</span>
            </div>
            {activeIndex === 4 && (
              <div className="faq-answer">
                 <div className="heading smalling">What to Bring:</div>
  <div className="flex-p">
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Travel Documents:</b> Ensure you have a valid passport and printed copies of your booking confirmation and insurance.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Comfortable Footwear:</b> Pack a pair of sturdy walking shoes or sneakers for navigating the stone pathways of Bhaktapur and the nature trails in Sarangkot.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Seasonal Layering:</b> Bring a warm jacket or fleece for the early morning sunrises in Nagarkot and Sarangkot, as temperatures drop significantly before dawn.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Personal Care:</b> Remember to pack sunscreen, sunglasses, and a hat to protect yourself from the strong high-altitude sun during your Phewa Lake boat ride.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Day Pack:</b> Use a small backpack to keep your camera, power bank, and rain gear handy for sudden mountain weather changes.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Currency & Cash:</b> Keep some local currency (NPR) for personal expenses, tips, and meals not included in the package.</p>
  </div>
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(5)}>
            <div className="faq-question">
              What about meal in this package?
              <span>{activeIndex === 5 ? "-" : "+"}</span>
            </div>
            {activeIndex === 5 && (
              <div className="faq-answer">
               <div className="heading smalling">Meal Plan Details</div>

<p className='overview-text'><b>Standard Inclusion:</b> Every morning begins with a fresh, delicious breakfast included at your hotel to fuel your day of exploration. This ensures you start your journey energized and ready for the sights ahead.</p>

<p className='overview-text'><b>Lunch & Dinner (Flexible):</b> To give you complete freedom over your palate, these meals are not included in the base price. Your guide will introduce you to top-rated local restaurants where you can pay directly, allowing you to discover the diverse flavors of Nepal at your own pace.</p>

<p className='overview-text'><b>Full-Board Upgrade (Recommended):</b> For those seeking a truly seamless and worry-free adventure, we can include all lunch and dinner charges in your package. We will handle all the arrangements and payments at every destination, so your only responsibility is to sit back, relax, and enjoy the trip.</p>
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(6)}>
            <div className="faq-question">
              Do you provide customized tours?
              <span>{activeIndex === 6 ? "-" : "+"}</span>
            </div>
            {activeIndex === 6 && (
              <div className="faq-answer">
                Yes, we offer fully customizable travel experiences you can see button of customize below just click it and our travel expert will contact you.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(7)}>
            <div className="faq-question">
              What Language are available for this package?
              <span>{activeIndex === 7 ? "-" : "+"}</span>
            </div>
            {activeIndex === 7 && (
              <div className="faq-answer">
                Our guides speak English, Hindi, and Chinese.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(8)}>
            <div className="faq-question">
              Do you offer group discounts?
              <span>{activeIndex === 8 ? "-" : "+"}</span>
            </div>
            {activeIndex === 8 && (
              <div className="faq-answer">
                When you see right side in desktop and little bit below in mobile screen we made a system where total price is calculated according to number of people and there may be available of more discount for group which is not mention in this system than our booking team will mention it while enquiry or booking.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(9)}>
            <div className="faq-question">
              How can I contact support?
              <span>{activeIndex === 9 ? "-" : "+"}</span>
            </div>
            {activeIndex === 9 && (
              <div className="faq-answer">
                You can reach us via email, phone and many more just see our contact us page.
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  </div>
<div className="overview-container">
  <div className="heading">Why Choose Us ?</div>

  <div className="flex-p">
   <p>1. From past 7 years we are continuously providing great service to our customer.</p>
   <p>2. After Booking with us your task is only to enjoy your trip.</p>
   <p>3. You can customize your holiday with our Destination expert.</p>
   <p>4. Providing better quality in compitative price is our main goal.</p>
   <p>5. Until your depature to your own country all responsibility like security is our duty.</p>
  </div>
</div>
<div className="overview-container width-hund">
<div className="review-section">

<div className="review-heading">
  What Our Travelers Say
</div>

<div className="review-wrapper">

  {/* REVIEW 1 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      The Everest Heli Tour was a dream come true. The views were unreal and
      the helicopter experience was smooth and luxurious.
    </div>

    <div className="review-user">
      <div className="user-avatar">A</div>
      <div className="user-info">
        <div className="user-name">Alex Morgan</div>
        <div className="user-country">United Kingdom</div>
      </div>
    </div>
  </div>

  {/* REVIEW 2 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Perfect for travelers with limited time. In just a few hours, we saw
      Everest up close without any physical effort.
    </div>

    <div className="review-user">
      <div className="user-avatar">S</div>
      <div className="user-info">
        <div className="user-name">Sophia Lee</div>
        <div className="user-country">Singapore</div>
      </div>
    </div>
  </div>

  {/* REVIEW 3 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Highly recommended! Stunning mountain views, professional crew, and
      an unforgettable helicopter flight over the Himalayas.
    </div>

    <div className="review-user">
      <div className="user-avatar">R</div>
      <div className="user-info">
        <div className="user-name">Rahul Verma</div>
        <div className="user-country">India</div>
      </div>
    </div>
  </div>

</div>
</div>
</div>
<div className="cta-section">

<div className="cta-button book" onClick={()=>seT(true)}>
  <FontAwesomeIcon icon={faCalendarCheck} />
  <div className="cta-text">Book Now</div>
</div>

<div className="cta-button customize" onClick={()=>seTe(true)}>
  <FontAwesomeIcon icon={faSliders} />
  <div className="cta-text">Customize</div>
</div>

<div className="cta-button review" onClick={()=>seTr(true)}>
  <FontAwesomeIcon icon={faStar} />
  <div className="cta-text">Review</div>
</div>

</div>
    </div>
    <section id='price'>
    <div className='Right'>
        <div className="in-right">
         <div className="out-right">
            <div className="out-in-right"> 
            <h3>Starting Price</h3>
            <div className="price-tag">
              <div className="icon-price-tag">
               <FontAwesomeIcon icon={faTag} className='icon'/>
              </div>
              <div className="icon-details">
                 <div className="right-price">
                  <p>$890</p>
                  <p className="per-person">/Per Person</p>
                 </div>
                 <p className='little'>All Price Inclusive</p>
            </div>
            </div>
            </div>
            <div className="number-of-traveller">
              <p>Number Of Travellers</p>
              <p className='lt'><FontAwesomeIcon icon={faBolt}></FontAwesomeIcon>Price Decreases When Travellers Increases</p>
              <div className="people-box">
              <FontAwesomeIcon icon={faMinus} className='people-box-icon'onClick={()=>{if(count>1){Setcount(count-1)}}}/>
                <p className='count'>{count}</p>
                <FontAwesomeIcon icon={faPlus} className='people-box-icon'onClick={()=>{Setcount(count+1)}}/>
              </div>
              <div className='Total-Amount'>
                <p className='total-price'>Total Amount</p>
                <p>${totalprice}</p>
              </div>
              <div className="booking-button">
                <Link to="/Terms" className="download">
                  
                  <h6>See Terms & Conditions</h6>
                </Link>
                <div className="booking-btn">
                  <button onClick={()=>seT(true)}>Book Now</button>
                  <button onClick={()=>seTe(true)}>Enquiry Now</button>
                </div>
              </div>
            </div>
         </div>
         </div>
         <div className="tour-rep-section">
      <h2 className="section-heading">Trip Expert</h2>
      
       <div className="rep-card">
        <div className="image-container">
          <img 
            src="/img/company/destination expert.png" 
            alt="Sales Manager" 
            className="rep-image" 
          />
        </div>
        
        <div className="rep-info">
          <h3 className="rep-name">Bishnu Pandey</h3>
           <div className="contact-item">
            <FontAwesomeIcon icon={faWhatsapp} className="icon effect" />
            <span>+977-9863841456</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faWeixin} className="icon effect" />
            <span>Bishnu Pandey</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faEnvelope} className="icon" />
            <a href="mailto:sales@yourtravelco.com">012shy1234@gmail.com</a>
          </div>
        </div>
      </div>
    </div>
        </div>
        </section>
   </div>
     <h2 className="hws">Similar Packages</h2>
     <PackageSlider packages={packages} />
     <section className='sticky-bott'>
     <div className="booking-btn">
      <button onClick={()=>seT(true)}>Book Now</button>
      <button onClick={()=>seTe(true)}>Enquiry Now</button>
      </div>
     </section>
     {opent &&( <section className="bookings">
      <div
      className="sw"
      onClick={() => seT(false)}
    >
      Back
      
    </div>
   <Bookingform src="/img/pokhara/pokhara1dslr.jpeg" title="Nepal's Golden Triangle"/></section>)}
{opente &&( <section className="bookings">
      <div
      className="sw"
      onClick={() => seTe(false)}
    >
      Back
      
    </div>
    <Enquiryform src="/img/pokhara/pokharadslr.jpeg" title="Nepal's Heritage & Horizon Tour"/></section> )}
{openr &&(  <section className="bookings">
      <div
      className="sw"
      onClick={() => seTe(false)}
    >
      Back
      
    </div>
    <Enquiryform src="/img/pokhara/pokharadslr.jpeg" title="Nepal's Heritage & Horizon Tour"/></section>)}
   </main>
  )
}
export default KathmandupokharaTour